import { FC, ReactNode } from 'react'

import { NavigationRightIcon } from '@icons/NavigationRightIcon'

import styles from './RangeWrapper.module.scss'

interface RangeWrapperProps {
  leftInput: ReactNode
  rightInput: ReactNode
}

export const RangeWrapper: FC<RangeWrapperProps> = (props) => {
  const { leftInput, rightInput } = props

  return (
    <div className={styles.rangeWrapper}>
      {leftInput}
      <NavigationRightIcon className={styles.arrow} />
      {rightInput}
    </div>
  )
}
